import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';
import {
  GetNavigationsResponse,
  GetWelcomeTileResponse,
  SearchClientResponse,
  SearchClientRequest,
  AlertResponse,
  AlertDismissRequest,
  CheckIpValidRequest,
  CheckIpValidResponse,
  UserAgreeAcceptParam,
  UserAgreeAcceptResponse,
  UserAgreementResponse,
  GetBrNavigationsResponse,
  ToolsResponse,
  ImpersonatorSignOutResponse,
  InstantALertData,
  UpdateUserLoginDateResponse,
} from './appstate.models';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { logErrorForLogout } from '@cigna/cigna-for-brokers/shared/util';
import uuid from 'uuid';
import { CookieService } from 'ngx-cookie-service';
import { addSeconds } from 'date-fns';

const PKMSLOGOUT = '/pkmslogout';

@Injectable({
  providedIn: 'root',
})
export class AppstateService {
  loadCount = 0;
  loadState: BehaviorSubject<boolean> = new BehaviorSubject(false);
  showErrorMsg: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(
    private _http: HttpClient,
    private _gw: AppStateGateway,
    private cookieService: CookieService,
  ) {}

  getAlerts(): Observable<AlertResponse> {
    return this._http.get<AlertResponse>(this._gw.getAlerts());
  }
  dismissAlert(
    dismissAlertRequest: AlertDismissRequest,
  ): Observable<AlertResponse> {
    return this._http.post<AlertResponse>(
      this._gw.dismissAlert(),
      dismissAlertRequest,
    );
  }
  getUserAgreement(): Observable<UserAgreementResponse> {
    return this._http.get<UserAgreementResponse>(
      this._gw.getUserAgreement('login-page', 'disclaimer'),
    );
  }
  updateTermsAgreementStatus(
    acceptReqest: UserAgreeAcceptParam,
  ): Observable<UserAgreeAcceptResponse> {
    const updatedRequest = { ...acceptReqest, service_reference_id: uuid.v4() };
    return this._http.put<UserAgreeAcceptResponse>(
      this._gw.updateTermsAgreementStatus(),
      updatedRequest,
    );
  }
  getBrokerNavigations(): Observable<GetBrNavigationsResponse> {
    return this._http
      .get<GetNavigationsResponse>(this._gw.getNavigations())
      .pipe(catchError((err) => this.catchAuthError(err)));
    // return of(GET_BR_NAVIGATIONS_RES_MOCK);
  }
  searchClient(
    searchClientRequest: SearchClientRequest,
  ): Observable<SearchClientResponse> {
    return this._http.post<SearchClientResponse>(
      this._gw.searchClient(),
      searchClientRequest,
    );
    // return of(GET_SEARCH_CLIENT_RES);
  }
  getTools() {
    return this._http.get<ToolsResponse>(this._gw.getTools());
  }
  getWelcomeTile(): Observable<GetWelcomeTileResponse> {
    return this._http.get<GetWelcomeTileResponse>(this._gw.getWelcomeTile());
  }
  getInstantAlertData(): Observable<InstantALertData> {
    return this._http.get<InstantALertData>(this._gw.getBusinessAlert());
  }
  catchAuthError(error: unknown) {
    if (error) {
      this.showErrorMsg.next(true);
    }
    return throwError(() => error);
  }

  checkIpValid(
    checkIpValidRequest: CheckIpValidRequest,
  ): Observable<CheckIpValidResponse> {
    return this._http.post<CheckIpValidResponse>(
      this._gw.checkIpValid(),
      checkIpValidRequest,
    );
    // return of(GET_SEARCH_CLIENT_RES);
  }
  logOut(): Observable<unknown> {
    const cignaDomain = '.cigna.com';
    const cignaBrokerDomain = '.cignaforbrokers.com';
    const hostname = window.location.hostname;
    const cookieMap = Object.keys(this.cookieService.getAll());
    const matchPattern = /^oo_/i;

    cookieMap.forEach((key) => {
      if (!matchPattern.test(key)) {
        this.cookieService.delete(key);
        this.cookieService.delete(key, '/', cignaDomain);
        this.cookieService.delete(key, '/', cignaBrokerDomain);
        this.cookieService.delete(key, '/', hostname);
      }
    });
    this.cookieService.set('isLogout', 'true', {
      expires: addSeconds(new Date(), 1000),
      path: '/',
      domain: cignaDomain,
    });

    return this._http.post(PKMSLOGOUT, '').pipe(catchError(logErrorForLogout));
  }
  impersonatorLogoutPost(): Observable<
    HttpResponse<ImpersonatorSignOutResponse>
  > {
    return this._http.post(PKMSLOGOUT, '', { observe: 'response' });
  }

  impersonatorLogoutGet(): Observable<
    HttpResponse<ImpersonatorSignOutResponse>
  > {
    return this._http.get(PKMSLOGOUT, { observe: 'response' });
  }

  showLoader() {
    this.loadCount += 1;
    this.loadState.next(true);
  }

  hideLoader() {
    this.loadCount = this.loadCount ? this.loadCount - 1 : 0;
    if (!this.loadCount) {
      this.loadState.next(false);
    }
  }

  staySignIn(): Observable<unknown> {
    return this._http.get(this._gw.getStaySignin());
  }

  updateUserLoginTime(): Observable<UpdateUserLoginDateResponse> {
    const updatedRequest = { service_reference_id: uuid.v4() };
    return this._http.put<UpdateUserLoginDateResponse>(
      this._gw.getUserLoginDateUpdateUrl(),
      updatedRequest,
    );
  }
}
